import React from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "./vfs_fonts";
import { forEach } from "lodash";

const ThoughtCatalogReport = (props) => {

    const generatePdf = () => {

        pdfMake.vfs = pdfFonts.pdfMake.vfs;

        pdfMake.fonts = {
            ChakraPetch: {
                normal: "ChakraPetch-Regular.ttf",
                bold: "ChakraPetch-Bold.ttf",
                italics: "ChakraPetch-Italic.ttf",
                bolditalics: "ChakraPetch-BoldItalic.ttf",
            },
            ChakraPetchMedium: {
                normal: "ChakraPetch-Medium.ttf",
            }
        };

        const docDefinition = {
            pageOrientation: "portrait",
            pageSize: "A4",
            pageMargins: 30,
            background: [{ image: 'pageBg', width: '630' }],
            defaultStyle: {
                font: "ChakraPetch",
                lineHeight: 1.25,
                fontSize: 12,
                columnGap: 5,
            },

            // background: { color: "#FFFFFF" },
            content: [
                pageData()
            ],

            styles: {
                header: {
                    fontSize: 18,
                    bold: true,
                    margin: [0, 0, 0, 10],
                    alignment: "center",
                }
            },

            images: {
                headerBg: 'pdfheaderbg.png',
                qrcode: 'pdfqrcode.png',
                pageBg: 'pdfbga4.png',
                borderline: 'borderbaseline.png',
            }
        };

        let fileName = props.fileName + ".pdf";

        pdfMake.createPdf(docDefinition).download(fileName);
        // pdfMake.createPdf(docDefinition).open();

        props.addUserActivityLog("Save PDF");
    };

    const pageData = () => {
        let result = [];
        result.push({
            image: "headerBg",
            width: 630,
            margin: [-30, -30, 0, 0],
        });

        result.push(
            {
                text: props.introDetails.name,
                margin: [0, 0, 0, 0],
                alignment: 'center',
                color: '#00FFCA',
                fontSize: 18,
                absolutePosition: { x: 0, y: 12 },
            }
        );

        result.push({
            table: {
                widths: ['*'],
                body: [
                    [
                        {
                            text: [{ text: 'Name: ', fontSize: 10, color: '#FFF' },
                            { text: "  " + props.userName, fontSize: 10, color: '#00FFCA' }]
                        }],
                    [{
                        text: [
                            { text: 'Location: ', fontSize: 10, color: '#FFF' },
                            { text: "  " + props.location, fontSize: 10, color: '#00FFCA', }]
                    }
                    ]
                ]
            },
            layout: 'noBorders',
            absolutePosition: { x: 450, y: 6 },
        });

        // result.push(
        //     {
        //         text: props.introDetails.subtitle,
        //         margin: [0, 15, 0, 0],
        //         alignment: 'center',
        //         bold: true,
        //         fontSize: 18,
        //     }
        // );

        result.push({
            text: props.introDetails.description,
            // color: '#FFF',
            margin: [0, 15, 0, 20],
        });

        forEach(props.tabContent, (tab) => {
            result.push({
                table: {
                    body: [[
                        {
                            text: tab.tabDisplayName,
                            margin: [-4, 0, 0, -4],
                            fontSize: 14,
                            bold: true,
                            border: [false, false, false, true],
                            borderColor: ['#00FFCA', '#00FFCA', '#00FFCA', '#005687'],
                        }]]
                }
            });
            result.push({
                image: "borderline",
                width: 570,
                margin: [0, -1, 0, 15],
            });

            result.push({
                text: tab.reflectionDesc,
                margin: [0, 0, 0, 15],
                // color: '#00FFCA',
            });

            forEach(tab.questions, (question) => {
                result.push({
                    margin: [0, 0, 0, 15],
                    table: {
                        widths: ['*'],
                        body: [
                            [
                                {
                                    stack: [
                                        {
                                            text: question.title,
                                            margin: [0, 0, 0, 0],
                                            font: 'ChakraPetchMedium'

                                            // color: '#00FFCA',
                                        },
                                        {
                                            text: question.answer,
                                            margin: [0, 0, 0, 0],
                                            italics: true,
                                            // color: '#FFF',
                                        }
                                    ],
                                    // borderColor: ['#00FFCA', '#00FFCA', '#00FFCA', '#00FFCA']
                                }
                            ]
                        ]
                    },
                    // layout: 'noBorders',
                });

            });
        });

        return result;

    };

    return <button className="cdx-btn print-pdf-button" onClick={() => generatePdf()}>{props.lable}</button>;
};

export default ThoughtCatalogReport;
